import _classnames from "classnames";
import { each, isArray, isObject } from "lodash-es";

export const classnames = _classnames;

export const combineText = ({
  prefix,
  text,
  separator = '-',
  position = 'start'
}) => {
  return `${position === 'start' ? prefix : text}${separator}${position === 'start' ? text : prefix}`;
};

export const combineTexts = ({
  prefix,
  texts,
  separator = '-',
  position = 'start'
}) => {
  const combinedTexts = [];
  if (isArray(texts)) {
    each(texts, (text) => {
      combinedTexts
        .push(combineText({
          prefix,
          text,
          separator,
          position,
        }));
    });
  } else if (isObject(texts)) {
    each(texts, (value, text) => {
      if (value) {
        combinedTexts
          .push(combineText({
            prefix,
            text,
            separator,
            position,
          }));
      }
    });
  } else {
    combinedTexts
      .push(combineText({
        prefix,
        texts,
        separator,
        position,
      }));
  }
  return combinedTexts;
};

export const combinePrefixes = (prefix, texts, separator, isSelf = false) => {
  return [
    ...isSelf ? [prefix] : [],
    ...combineTexts({ prefix, texts, separator })
  ];
};

export const combinesuffixes = (suffix, texts, separator, isSelf = false) => {
  return [
    ...isSelf ? [suffix] : [],
    ...combineTexts({ prefix: suffix, texts, separator, position: "end" })
  ];
};
